<template>
<!-- 新闻 -->
    <div>
        <!-- 图片 -->
        <div class="topImg">
            <span>
                动态新闻
            </span>
        </div>
        <div class="companNewsAll">
            <div class="wow fadeInUp companNews" data-wow-delay=".12s" v-for="(item,index) in listNews" :key="index">
                <div class="newsImg">
                    <img loading="lazy" :src="item.coverImageUrl" @click="newInfoClick(item.id)">
                </div>
                <div class="newsContent" @click="newInfoClick(item.id)">
                    <div class="newsTitle">
                        <div><a>{{item.title}}</a></div>
                        <div class="chevronsleftDiv">
                            <div class="chevronsleft"></div>
                            <span>MORE</span>
                        </div>
                    </div>
                    <div class="newsTime">
                        <span>{{item.newsDate}}</span>
                        <div>
                            <img loading="lazy" src="@/assets/img/xiaoyanjing.png">
                            <span>{{item.views}}</span>
                        </div>
                    </div>
                    <div class="content textHide ">
                        {{item.introduce}}
                    </div>
                </div>
            </div>
        </div>
        <div class="pagination">
            <div class="block">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="prev, pager, next"
                    :total="count">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
// getListNews 查询新闻
// incrementalViews 修改浏览量
import {getListNews,incrementalViews} from '@/api'
export default {
    name: 'YinshiOffcialwebsiteCompanyNews',

    data() {
        return {
            // 新闻
            listNews:[],
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            // 总条数
            count:0
        };
    },

    mounted() {
    },

    methods: {
        ...mapMutations(['GoTop']),
        // 新闻点击事件
        async newInfoClick(id){
            // 修改浏览量
            await incrementalViews(id)
            this.$router.push({path:'/dynamicNews/newsDetails',query:{id:id}});
        },
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectGetListNews()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectGetListNews()
        },
        // 修改浏览量
        async updateIncrementalViews(id){
            let res = await incrementalViews(id);
            if(res.code == 200){
                this.$message({ message: '修改成功！', type: 'success' });
                this.selectNewsInfo()
            }else{
                this.$message({message: '修改失败！',type: 'error'});
            }
        },
        // 查询新闻
        async selectGetListNews(){
            let res = await getListNews({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            if(res.code == 200){
                this.listNews = res.data
                this.count = res.page.count
            }
            this.$nextTick(() => {
                // new this.$WOW.WOW().init()
            });
        }
    },
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        // this.GoTop()
        // 查询新闻
        this.selectGetListNews()
    }
};
</script>

<style lang="scss" scoped>
// 顶部图片
.topImg{
    background: url(../../assets/img/xinwen.jpg);
}
// 新闻内容
.companNewsAll{
    padding:70px 270px 30px 270px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .companNews{
        display: flex;
        margin-top: 50px;
        width: 100%;
        // 新闻图片
        .newsImg{
            width: 296px;
            height: 214px;
            flex-shrink: 0;
            background: #EFEFEF;
            overflow: hidden;
            cursor: pointer;
            img{
                width: 100%;
                height: 100%;
                transition: .2s;
            }
            img:hover{
                transform: scale(1.1);
            }
        }
        // 新闻内容
        .newsContent{
            padding:0px 40px 19px 40px;
            display: flex;
            flex-direction: column;
            // justify-content: center;
            width: 100%;
            transition: .2s all;
            cursor: pointer;
            // 标题
            .newsTitle{
                display: flex;
                justify-content: space-between;
                margin-top: 26px;
                div a{
                    font-size: 18px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                    font-weight: 700;
                    transition: .2s all;
                    color: #444444;
                }
                .chevronsleftDiv{
                    display: flex;
                    align-items: center;
                    .chevronsleft{
                        background: url(../../assets/img/gongsixinwne.png);
                        background-size: 100% 100%;
                        width: 50px;
                        height: 7px;
                        transition: .2s all;
                    }
                    span{
                        font-size: 18px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        font-weight: 400;
                        color: #555555;
                        margin-left:16px;
                        transition: .2s all;
                    }
                }
                img{
                    width: 35px;
                    height: 23px;
                }
            }
            // 时间
            .newsTime{
                margin-top: 20px;
                font-size: 14px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                color: #c6c6c6;
                display: flex;
                margin-left: 3px;
                div{
                    margin-left:30px;
                    display: flex;
                    align-items: center;
                    img{
                        width: 16px;
                        height: 13px;
                    }
                    span{
                        margin-left: 10px;
                    }
                }

            }
            // 内容
            .content{
                margin-top: 10px;
                font-size: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: left;
                color: #666666;
                line-height: 32px;
                -webkit-line-clamp:3;
                padding:0px;
            }
        }
        // 鼠标移上去
        .newsContent:hover{
            background: #eee;
            // 标题
            .newsTitle a{
                color:#3B589A !important;
            }
            .chevronsleftDiv{
                .chevronsleft{
                    background: url(../../assets/img/gongsixinwne01.png);
                }
                span{
                    color:#3B589A !important;
                }
            }
            

        }
    }
}
// 分页
.pagination{
    padding: 30px 270px 70px 270px;
    text-align: center;
}
</style>